import { useEffect, useState } from "react";
import api from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";
import { useI18n } from "../i18n/I18nContext.jsx";
import DepartmentForm from "../components/DepartmentForm.jsx";
import "../styles/Zones.css";

export default function Departments() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [departments, setDepartments] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [editingDepartment, setEditingDepartment] = useState(null);
  const isAdmin = user?.role === "SUPER_ADMIN" || user?.role === "CORP_ADMIN";

  const fetchDepartments = () => {
    api.get("/departments/")
      .then((r) => setDepartments(r.data.results || r.data))
      .catch((err) => console.error("Failed to fetch departments:", err));
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  const handleDelete = async (id, name) => {
    if (!window.confirm(`${t("deleteConfirm")} "${name}"?`)) {
      return;
    }
    try {
      await api.delete(`/departments/${id}/`);
      fetchDepartments();
    } catch (err) {
      alert(t("deleteDeptFail"));
    }
  };

  return (
    <div className="page-departments">
      <div className="page-header" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "1.5rem" }}>
        {isAdmin && (
          <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
            + {t("addDepartment")}
          </button>
        )}
      </div>

      {departments.length === 0 ? (
        <div className="card" style={{ textAlign: "center", color: "var(--muted)", padding: "2rem" }}>
          {t("noDepartments")}
        </div>
      ) : (
        <div className="zones-grid">
          {departments.map((d) => (
            <div key={d.id} className="zone-card" style={{ cursor: "default" }}>
              <div className="zone-card-header">
                <h3 className="zone-card-title">{d.name}</h3>
                <span className="tag-pill">
                  <i className="ti ti-building-community" style={{ marginRight: 4 }}></i>
                  Dept
                </span>
              </div>

              <div className="zone-card-body">
                {d.cug_number && (
                  <div className="zone-info-item">
                    <i className="ti ti-phone"></i>
                    <span>CUG: <strong>{d.cug_number}</strong></span>
                  </div>
                )}
                <div className="zone-info-item">
                  <i className="ti ti-calendar"></i>
                  <span>Created {new Date(d.created_at).toLocaleDateString()}</span>
                </div>
              </div>

              {isAdmin && (
                <div className="zone-card-footer" style={{ justifyContent: "flex-end", gap: 8 }}>
                  <button
                    className="btn btn-outline"
                    style={{ padding: "6px 14px", fontSize: "13px" }}
                    onClick={() => setEditingDepartment(d)}
                  >
                    <i className="ti ti-edit" style={{ marginRight: 4 }}></i>
                    {t("edit")}
                  </button>
                  <button
                    className="btn btn-outline"
                    style={{ borderColor: "#ef4444", color: "#ef4444", padding: "6px 14px", fontSize: "13px" }}
                    onClick={() => handleDelete(d.id, d.name)}
                  >
                    <i className="ti ti-trash" style={{ marginRight: 4 }}></i>
                    {t("delete")}
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {showAdd && (
        <DepartmentForm
          onClose={() => setShowAdd(false)}
          onSuccess={() => {
            setShowAdd(false);
            fetchDepartments();
          }}
        />
      )}

      {editingDepartment && (
        <DepartmentForm
          department={editingDepartment}
          onClose={() => setEditingDepartment(null)}
          onSuccess={() => {
            setEditingDepartment(null);
            fetchDepartments();
          }}
        />
      )}
    </div>
  );
}
